// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInHours/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInHours = convertToFP(fn, 2);
export default differenceInHours;